module.exports = __webpack_public_path__ + "static/media/babbage.e31034f9.gif";